import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Controller from '@ember/controller';
import { restartableTask, timeout } from 'ember-concurrency';
import escapeRegExp from 'ilios-common/utils/escape-reg-exp';
import { set } from '@ember/object';
export default class CourseVisualizeInstructorsController extends Controller {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "queryParams", ['name']);
    _defineProperty(this, "name", '');
    _defineProperty(this, "setName", _buildTask(() => ({
      context: this,
      generator: function* (name) {
        const clean = escapeRegExp(name);
        if (clean) {
          yield timeout(250);
        }
        set(this, 'name', clean);
      }
    }), null, "setName", "restartable"));
  }
}